var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M1 1h6.5v6.5H1V1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M8.5 1H15v6.5H8.5V1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M1 8.5h6.5V15H1V8.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M8.5 8.5H15V15H8.5V8.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftSvgrepoCom1);
export default __webpack_public_path__ + "static/media/microsoft-svgrepo-com1.f6197f18a1a75a99331a142025cfaf73.svg";
export { ForwardRef as ReactComponent };